import PropTypes from 'prop-types';
import faresShape from './fares';
import stationShape from './station';
import passengersShape from './passengers';

export default PropTypes.shape({
  outbound: PropTypes.shape({
    isWheelchair: PropTypes.bool,
    totalPriceOfOriginalExchangeItems: PropTypes.number,
    journeys: faresShape,
    origin: stationShape,
    destination: stationShape
  }),
  inbound: PropTypes.shape({
    isWheelchair: PropTypes.bool,
    totalPriceOfOriginalExchangeItems: PropTypes.number,
    journeys: faresShape,
    origin: stationShape,
    destination: stationShape
  }),
  passengers: passengersShape,
  productFamiliesWithFares: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      code: PropTypes.string
    })
  )
});
